var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTvk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#30FFE0",
    d: "M12.951 18.75c-.146.244-.291.536-.63.536c-.291 0-.531-.292-.677-.536L5.914 8.23c-.142-.292-.287-.583-.339-.922c-.047-.535.245-.878.776-.878h3.934c.532 0 .922.244 1.213.78c.63 1.264 1.067 2.335 1.89 3.505c1.942 2.19 3.836 0 4.612-.878z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTvk);
export default __webpack_public_path__ + "static/media/tvk.773268ce010ad67f19bd5371cd1f10e8.svg";
export { ForwardRef as ReactComponent };